<template>
    <div class="container">
        <div class="form-group" :class="windowWidth <= 500 ? '':'input-group'">
            <b-form-select v-model="value.types" :options="filters[locale].Type" @change="typeChanged"/>
            <b-form-select v-model="value.subTypes" :options="filters[locale].SubType" @change="subTypeChanged"/>
            <b-form-select v-model="value.status" :options="[{ value: undefined, text:  langQuickSearch.status[locale] },{ value: 'selling', text: langQuickSearch.selling[locale] },{ value: 'sold', text:  langQuickSearch.sold[locale] }]" @change="statusChanged" v-if="showStatus === true"/>
            <b-form-select v-model="value.provinces" :options="[{ value: undefined, text:  langQuickSearch.province[locale] }].concat(PROVINCES.map(item => {return item;}).sort((a, b) => {return a.toString().localeCompare(b);}))" @change="provinceChanged"/>
            <b-form-select v-model="value.cities" :options="[{ value: undefined, text:  langQuickSearch.city[locale] }].concat(CITIES.map(item => {if(value.provinces === item.Maakunta || !value.provinces) return item.Kunta;}).filter(item => !!item).sort((a, b) => {return a.toString().localeCompare(b);}))"  @change="cityChanged"/>
        </div>
        <div class="price-range-controls">
            <div class="row">
                <form-input class="col" :inputType="'number'" :labelText="langQuickSearch.minPrice[locale]" :min="0" :placeholder="langQuickSearch.minPrice[locale]" v-model="value.minPrice" @input="priceMinChanged"/>
            </div>
            <div class="row">
                <form-input class="col" :inputType="'number'" :labelText="langQuickSearch.maxPrice[locale]" :min="0" :placeholder="langQuickSearch.maxPrice[locale]" v-model="value.maxPrice" @input="priceMaxChanged"/>
            </div>
        </div>
        <div class="form-group">
            <label for="text-search" class="text-left" style="font-size: 0.8em; display: block; margin: 0; margin-left: 10px;"><strong>{{langQuickSearch.textSearchPlaceholder[locale]}}</strong></label>
            <b-form-input id="text-search" v-model="value.text" :placeholder="langQuickSearch.textSearchPlaceholder[locale]" @input="textChanged"/>
        </div>
        <form-filter-condition :labelText="langQuickSearch.selectACondition[locale]" v-model="value.condition" @change="conditionChanged" :options="filters[locale].selectCondtionOptions" :allowedValues="filters[locale].selectCondtionOptions.map(item => (item.value))" :tooltipTitle="langQuickSearch.selectAConditionToolTip[locale]"/>
        <nettipyora-button :text="`${langQuickSearch.search[locale]} ${count > 0 ? '('+count+')':'(0)'}`" :loading="loading" :clickHandler="clickHandler" :className="'btn-primary'"  />
    </div>
</template>

<script>
import NettipyoraButton from './NettipyoraButton.vue';
import FormInput from '@/components/FormInput';
import { mapState } from 'vuex';
import debounce from '@/plugins/debaunce';
import { CITIES, PROVINCES } from '@/store/constant';
import langQuickSearch from '@/store/lang/quickSearch';
import FormFilterCondition from '@/components/FormFilterCondition';

export default {
    name: 'QuickSearch',
    components: {
        NettipyoraButton,
        FormInput,
        FormFilterCondition
    },
    props: {
        search: Function,
        queryChanged: Function,
        loading: Boolean,
        count: Number,
        showStatus: Boolean,
        value: {type: Object, default() {
            return {}
        }}
    },
    computed: mapState({
        locale: state => state.locale,
        filters: state => state.filters
    }),
    data() {
        return {
            CITIES, PROVINCES, langQuickSearch,
            windowWidth: 0,
            condition: undefined
        }
    },
    mounted() {
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);

            //Init
            this.getWindowWidth()
        });
    },
    methods: {
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        clickHandler() {
            this.search(this.value);
        },
        changed(query) {
            query.searchType = "count";
            this.queryChanged(query);
        },
        typeChanged(val) {
            const query = JSON.parse(JSON.stringify(this.value));
            query.types = val;
            this.changed(query);
        },
        subTypeChanged(val) {
            const query = JSON.parse(JSON.stringify(this.value));
            query.subTypes = val;
            this.changed(query);
        },
        provinceChanged(val) {
            let valid = false;
            for(let i=0; i<this.CITIES.length; i++) {
                if(this.CITIES[i].Maakunta === val && this.value.cities === this.CITIES[i].Kunta) {
                    valid = true;
                    break;
                }
            }
            if(!valid) this.value.cities = null;
            const query = JSON.parse(JSON.stringify(this.value));
            query.provinces = val;
            this.changed(query);
        },
        cityChanged(val) {
            for(let i=0; i<this.CITIES.length; i++) {
                if(this.CITIES[i].Kunta === val) {
                    this.value.provinces = this.CITIES[i].Maakunta;
                    break;
                }
            }
            const query = JSON.parse(JSON.stringify(this.value));
            query.cities = val;
            this.changed(query);
        },
        statusChanged(val) {
            const query = JSON.parse(JSON.stringify(this.value));
            query.status = val;
            this.changed(query);
        },
        priceMinChanged: debounce(function (val) {
            const query = JSON.parse(JSON.stringify(this.value));
            query.minPrice = val;
            this.changed(query);
        }, 500),
        priceMaxChanged: debounce(function (val) {
            const query = JSON.parse(JSON.stringify(this.value));
            query.maxPrice = val;
            this.changed(query);
        }, 500),
        textChanged: debounce(function (val) {
            const query = JSON.parse(JSON.stringify(this.value));
            query.text = val;
            this.changed(query);
        }, 500),
        conditionChanged(val) {
            const query = JSON.parse(JSON.stringify(this.value));
            query.condition = val;
            this.changed(query);
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
}
</script>

